// extracted by mini-css-extract-plugin
export default {"contents-container":"xfbVO62T_PPnDbEJKRwg","fail-items-section":"sxuGQAUR2WO0GDj8Kf8e","table-wrapper":"kkCfN2cDKeDEqj2wSXsy","table":"Mcd0qCMTCxffmECteV5T"};